import PropTypes from 'prop-types'

/**
 * @typedef {string[]|object[]} TagWrapperItems
 */

/**
 * A configuration object for the tag wrapper items.
 *
 * @type {string[]|object[]}
 */
export const tagWrapperItemsPropType = PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
    PropTypes.arrayOf(PropTypes.element)
])
